import React from "react";
import { Modal, Tooltip, Button, message } from "antd";
import { workflowTwoById } from "../../../../libs/apis";
import { WorkflowTwoI } from "../../../../libs/interfaces";
import { Box, Grid } from "@mui/material";
import type { Dayjs } from "dayjs";
import { CloseOutlined, FundViewOutlined } from "@ant-design/icons";
import { OneCard, OneVideo, ProcessStateAlert } from "../../../../libs/shared";
interface OnePhotoI {
  src: string | number | boolean | Dayjs | null | undefined;
  alt: string;
  showAlt?: boolean;
  type?: "video-charging" | "video-container";
}

interface OneCardI {
  title: string;
  photos: OnePhotoI[];
  value?: string;
  noLine?: boolean;
  type:
    | "external"
    | "internal"
    | "exit"
    | "naviera"
    | "exporter"
    | "other"
    | "gps"
    | "video"
    | "charging"
    | "container"
    | "video-charging";
}

interface ShowContainerPropsI {
  id: number;
}

export const ShowContainer = ({ id }: ShowContainerPropsI) => {
  const [open, setOpen] = React.useState(false);
  const [showContainer, setShowContainer] = React.useState(false);

  React.useEffect(() => {
    if (showContainer) {
      setOpen(true);
    }
  }, [showContainer]);

  const handleClose = () => {
    setShowContainer(false);
    setOpen(false);
  };

  return (
    <>
      <Tooltip arrow={false} title="Show">
        <Button
          size="small"
          type="dashed"
          onClick={() => setShowContainer(true)}
          icon={<FundViewOutlined />}
        />
      </Tooltip>
      {showContainer && (
        <ModalContainer open={open} onClose={handleClose} id={id} />
      )}
    </>
  );
};

interface ModalContainerPropsI {
  open: boolean;
  onClose: () => void;
  id: number;
}

export const ModalContainer = ({ open, onClose, id }: ModalContainerPropsI) => {
  const [isLoading, setLoading] = React.useState(true);
  const [data, setData] = React.useState<WorkflowTwoI>({
    container: "",
  } as WorkflowTwoI);
  const [cards, setCards] = React.useState<OneCardI[]>([]);
  const [cardVideos, setCardVideos] = React.useState<OnePhotoI[]>([]);
  const [totalPhotos, setTotalPhotos] = React.useState<string[]>([]);

  React.useEffect(() => {
    handleGetData();
    return () => {
      setCards([]);
      setData({ container: "" } as WorkflowTwoI);
      setLoading(true);
    };
  }, []);

  const handleGetData = async () => {
    try {
      let dataContainer: WorkflowTwoI;
      const { data: dataContainerGet } = await workflowTwoById(id);
      if (!dataContainerGet) return;
      dataContainer = dataContainerGet;
      setData(dataContainerGet);

      const lasFotos: string[] = [];
      const arrCards: any[] = [];

      const videos: OnePhotoI[] = [];

      const chargingProcessPhotos = [
        {
          title: "Foto 1",
          src: dataContainer.chargingProcessPhoto1,
          alt: "Proceo de carga 1",
          comment: dataContainer.chargingProcessComment1,
          type: "charging",
        },
        {
          title: "Foto 2",
          src: dataContainer.chargingProcessPhoto2,
          alt: "Proceo de carga 1",
          comment: dataContainer.chargingProcessComment2,
          type: "charging",
        },
      ];

      chargingProcessPhotos.forEach((photo) => {
        arrCards.push({
          title: photo.title,
          noLine: true,
          photos: [{ src: photo.src, alt: photo.alt, showAlt: false }],
          value: photo.comment,
          type: "charging",
        });
        lasFotos.push(photo.src);
      });

      videos.push({
        src: dataContainer.chargingProcessVideo,
        alt: "Video Proceso de Carga",
        type: "video-charging",
      });

      const containerPhotos = [
        {
          title: "Foto 1",
          src: dataContainer.containerPanoramicPhoto,
          alt: "Contenedor 1",
          comment: dataContainer.containerPanoramicComment,
          type: "container",
          showAlt: true,
        },
        {
          title: "Foto Botella Naviera",
          src: dataContainer.navieraBottlePhoto,
          alt: "Contenedor",
          comment: dataContainer.navieraBottleComment,
          type: "container",
          showAlt: true,
        },
        {
          title: "Foto Cable Naviera",
          src: dataContainer.navieraWirePhoto,
          alt: "Contenedor",
          comment: dataContainer.navieraWireComment,
          type: "container",
          showAlt: true,
        },
        {
          title: "Foto Etiqueta Naviera",
          src: dataContainer.navieraLabelPhoto,
          alt: "Contenedor",
          comment: dataContainer.navieraLabelComment,
          type: "container",
          showAlt: true,
        },
        {
          title: "Foto Botella Exportador",
          src: dataContainer.exporterBottlePhoto,
          alt: "Contenedor 3",
          comment: dataContainer.exporterBottleComment,
          type: "container",
          showAlt: true,
        },
        {
          title: "Foto Cable Exportador",
          src: dataContainer.exporterWirePhoto,
          alt: "Contenedor",
          comment: dataContainer.exporterWireComment,
          type: "container",
          showAlt: true,
        },
        {
          title: "Foto Etiqueta Exportador",
          src: dataContainer.exporterLabelPhoto,
          alt: "Contenedor",
          comment: dataContainer.exporterLabelComment,
          type: "container",
          showAlt: true,
        },
        {
          title: "Foto Botella Otro",
          src: dataContainer.otherBottlePhoto,
          alt: "Contenedor 4",
          comment: dataContainer.otherBottleComment,
          type: "container",
          showAlt: true,
        },
        {
          title: "Foto Cable Otro",
          src: dataContainer.otherWirePhoto,
          alt: "Contenedor",
          comment: dataContainer.otherWireComment,
          type: "container",
          showAlt: true,
        },
        {
          title: "Foto Etiqueta Otro",
          src: dataContainer.otherLabelPhoto,
          alt: "Contenedor",
          comment: dataContainer.otherLabelComment,
          type: "container",
          showAlt: true,
        },
        {
          title: "Foto Gps",
          src: dataContainer.gpsPhoto,
          alt: "Contenedor",
          comment: dataContainer.gpsComment,
          type: "container",
          showAlt: true,
        },
        {
          title: "Foto Sello Gps",
          src: dataContainer.gpsStampPhoto,
          alt: "Contenedor",
          comment: dataContainer.gpsStampComment,
          type: "container",
          showAlt: true,
        },
      ];

      containerPhotos.forEach((photo) => {
        arrCards.push({
          title: photo.title,
          noLine: true,
          photos: [{ src: photo.src, alt: photo.alt, showAlt: false }],
          value: photo.comment,
          type: "container",
        });
        lasFotos.push(photo.src);
      });

      // Fotos dinámicas (nombre = comment)
      (dataContainer.images || [])
        .filter((img) => img.src && img.section)
        .forEach((img) => {
          const name = (img.comment || "").trim() || "Foto adicional";
          arrCards.push({
            title: name,
            noLine: true,
            photos: [{ src: img.src, alt: name, showAlt: false }],
            value: "",
            type: "container",
          });
          lasFotos.push(img.src);
        });

      videos.push({
        src: dataContainer.exitDoorVideo,
        alt: "Video Puerta",
        type: "video-container",
      });

      videos.push({
        src: dataContainer.exitEngineryVideo,
        alt: "Video Maquinaria",
        type: "video-container",
      });

      setTotalPhotos(lasFotos);
      setCards(arrCards);
      setCardVideos(videos);
      setLoading(false);
    } catch (err: any) {
      message.error((err as Error).message);
      setLoading(false);
    }
  };

  return (
    <Modal
      title={
        <p
          style={{
            color: "white",
            padding: "10px",
            fontWeight: "bold",
            fontSize: "1.2rem",
            textAlign: "center",
            background: "linear-gradient(to bottom, #FFA500, #FF4500)", // Naranja a rojo
            borderRadius: "5px",
            width: "98%",
            margin: "0 auto",
          }}
        >
          {`CONTENEDOR N° ${data.container}`}
        </p>
      }
      closeIcon={
        <CloseOutlined
          style={{
            background: "red",
            color: "white",
            padding: "5px",
            borderRadius: "5px",
          }}
        />
      }
      footer={null}
      loading={isLoading}
      open={open}
      onClose={onClose}
      onCancel={onClose}
      width={810}
      centered={true}
      zIndex={1602}
      destroyOnClose={true}
      style={{ padding: 0 }}
    >
      <Box sx={{ overflowY: "auto", maxHeight: 550, p: 1 }}>
        <ProcessStateAlert
          state={data.processState}
          reason={data.processStateReason}
        />
        <DataSection data={data} />
        <PhotoSection
          title="Proceso de Carga"
          type="charging"
          cards={cards}
          totalPhotos={totalPhotos}
        />
        <PhotoSection
          title="Fotos Contenedor Full"
          type="container"
          cards={cards}
          totalPhotos={totalPhotos}
        />
        {/* <VideoSection videos={cardVideos} /> */}
      </Box>
    </Modal>
  );
};

const DataSection = ({ data }: { data: WorkflowTwoI }) => {
  const rows = [
    { name: "Producto", value: data.product },
    { name: "Presentación", value: data.presentation },
    { name: "Número de Pallet", value: data.palletNumber },
    { name: "Número de Presentación", value: data.presentationNumber },
    { name: "Número de Muestreo", value: data.samplingNumber },
    ...(data.extraFields || []).filter((f) => f.name),
  ].filter((r) => r.value);

  if (rows.length === 0) return null;

  return (
    <>
      <Box
        sx={{
          textAlign: "center",
          mb: 2,
          mt: 2,
          bgcolor: "transparent",
          borderRadius: "4px",
          background:
            "linear-gradient(to bottom, #A9A9A9 0%,#032263 50%,rgb(29, 68, 152) 100%)",
        }}
      >
        <h3 style={{ color: "white" }}>Datos del Proceso</h3>
      </Box>
      <Box
        sx={{
          display: "grid",
          gap: 1,
          gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
        }}
      >
        {rows.map((r, idx) => (
          <Box
            key={`${r.name}-${idx}`}
            sx={{
              border: "1px solid #d9d9d9",
              borderRadius: "4px",
              p: 1,
              wordBreak: "break-word",
            }}
          >
            <div style={{ fontSize: 11, fontWeight: "bold", color: "#555" }}>
              {r.name}
            </div>
            <div style={{ fontSize: 14 }}>{r.value}</div>
          </Box>
        ))}
      </Box>
    </>
  );
};

const PhotoSection = ({
  title,
  type,
  cards,
  totalPhotos,
}: {
  title: string;
  type: string;
  cards: OneCardI[];
  totalPhotos: string[];
}) => (
  <>
    <Box
      sx={{
        textAlign: "center",
        mb: 2,
        mt: 4,
        bgcolor: "transparent",
        borderRadius: "4px",
        background:
          "linear-gradient(to bottom, #A9A9A9 0%,#032263 50%,rgb(29, 68, 152) 100%)",
      }}
    >
      <h3 style={{ color: "white" }}>{title}</h3>
    </Box>
    <Box
      sx={{
        display: "grid",
        gap: 2,
        gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
      }}
    >
      {cards
        .filter((el) => el.type === type)
        .map((el) => (
          <OneCard data={el} key={el.title} lasFotos={totalPhotos} />
        ))}
    </Box>
  </>
);

const VideoSection = ({ videos }: { videos: OnePhotoI[] }) => (
  <>
    <Box
      sx={{
        textAlign: "center",
        mb: 4,
        mt: 8,
        bgcolor: "transparent",
        borderRadius: "4px",
        background:
          "linear-gradient(to bottom, #A9A9A9 0%,#032263 50%,rgb(29, 68, 152) 100%)",
      }}
    >
      <h3 style={{ color: "white" }}>Videos</h3>
    </Box>
    <Grid container spacing={2} justifyContent={"center"}>
      {videos.map((video, index) => (
        <Grid item xs={12} sm={6} md={4} key={index}>
          <OneVideo src={video.src!} alt={video.alt} />
        </Grid>
      ))}
    </Grid>
  </>
);
